'use client'

// src/useWindowResize.ts
import { useEffect, useState } from "react";
var useWindowResize = ({ width = 0, height = 0 } = {}) => {
  const [state, setState] = useState(() => ({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0
  }));
  useEffect(() => {
    const handler = () => {
      setState((prev) => {
        const next = {
          width: window.innerWidth,
          height: window.innerHeight
        };
        return prev.width === next.width && prev.height === next.height ? prev : next;
      });
    };
    handler();
    window.addEventListener("resize", handler, {
      capture: false,
      passive: true
    });
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);
  return {
    width: state.width,
    height: state.height,
    isLessWidth: state.width <= width,
    isLessHeight: state.height <= height
  };
};

export {
  useWindowResize
};
//# sourceMappingURL=chunk-S3CKVFD7.mjs.map